<template>
  <va-create-layout>
    <categories-form :title="title" :item="item" />
  </va-create-layout>
</template>

<script>
export default {
  props: ["title", "item"],
};
</script>
